import React from 'react'

import Navbar from '../components/Navbar'
import Form from '../components/AddDataForm'
import context from '../context';

const AddData = (props) => {
  return (
    <div>
      <Navbar/>
      <context.Consumer>
        {
          data => <Form {...props} user={data.user}/>
        }
      </context.Consumer>
    </div>
  )
}

export default AddData

